import {useEffect, useRef, useState} from "react";

/**
 * Keeps a collapsible's open state in sync with a derived "should be open"
 * signal (e.g. tool still running). Manual toggles stick until the signal
 * changes again.
 */
export function useSyncCollapsibleOpen(desiredOpen: boolean) {
   const [open, setOpen] = useState(desiredOpen);
   const prevDesired = useRef(desiredOpen);

   useEffect(() => {
      if (desiredOpen !== prevDesired.current) {
         setOpen(desiredOpen);
         prevDesired.current = desiredOpen;
      }
   }, [desiredOpen]);

   return [open, setOpen] as const;
}
